import React from 'react';
import classNames from 'classnames';

export const TimeInput = ({
  className, value, onChange, step = 1, disabled = false,
}) => (
  <input
    className={classNames('border border-border-dark rounded px-2', className)}
    type="time"
    step={step}
    value={value}
    onChange={onChange}
    disabled={disabled}
  />
)

export default TimeInput;
